import { FormikProps } from "formik";

import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import {
  ContactDetailsField,
  useContactDetails,
} from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/sections/address/hooks/useContactDetails";

import { ContactDetailRow } from "./components/ContactDetailRow";

interface Props {
  formik: FormikProps<EditClientType>;
  fieldName: ContactDetailsField;
  valueLabel: string;
  addLabel: string;
  removeLabel: string;
}

export function ContactDetailRows({ formik, fieldName, valueLabel, addLabel, removeLabel }: Props) {
  const { entries, remove, add } = useContactDetails(formik, fieldName);

  return entries.map((entry, index) => (
    <ContactDetailRow
      key={entry.id ?? `${fieldName}-${index}`}
      formik={formik}
      fieldName={fieldName}
      index={index}
      valueLabel={valueLabel}
      addLabel={addLabel}
      removeLabel={removeLabel}
      onAdd={add}
      onRemove={() => remove(index)}
    />
  ));
}
